export const REMIND_USERNAME_START = 'REMIND_USERNAME_START';
export const REMIND_USERNAME_SUCCESS = 'REMIND_USERNAME_SUCCESS';
export const REMIND_USERNAME_ERROR = 'REMIND_USERNAME_ERROR';
export const CLEAR_REMIND_USERNAME_STORE =
  'CLEAR_REMIND_USERNAME_STORE';
